var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconErro(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "0C200E7E-A82A-40D3-B931-984967648AA8") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Web",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "8.6-Modal-j\\xE1-cadastrado",
    transform: "translate(-700.000000, -237.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(436.000000, 197.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(264.000000, 40.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#DDE4FC",
    fill: "#F6F8FF",
    cx: 20,
    cy: 20,
    r: 19.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Status/check-circle-1",
    transform: "translate(8.828571, 8.828571)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "bounds",
    x: 0,
    y: 0,
    width: 23.3142857,
    height: 23.3142857
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6571429,21.3714286 C6.30068569,21.3714286 1.9428571,17.0145715 1.9428571,11.6571429 C1.9428571,6.30165712 6.30068569,1.9428571 11.6571429,1.9428571 C17.0136,1.9428571 21.3714286,6.30068569 21.3714286,11.6571429 C21.3714286,17.0145715 17.0136,21.3714286 11.6571429,21.3714286 Z M11.6571429,3.88571425 C7.37217141,3.88571425 3.88571425,7.37217141 3.88571425,11.6571429 C3.88571425,15.9421143 7.37217141,19.4285715 11.6571429,19.4285715 C15.9421143,19.4285715 19.4285715,15.9421143 19.4285715,11.6571429 C19.4285715,7.37217141 15.9421143,3.88571425 11.6571429,3.88571425 Z M12.6285714,14.5714286 L12.6285714,10.6857143 C12.6285714,10.1494857 12.1943429,9.71428571 11.6571429,9.71428571 L9.71428571,9.71428571 L9.71428571,11.6571429 L10.6857143,11.6571429 L10.6857143,14.5714286 L8.74285713,14.5714286 L8.74285713,16.5142857 L14.5714286,16.5142857 L14.5714286,14.5714286 L12.6285714,14.5714286 Z M11.6571429,8.98571427 C12.3277743,8.98571427 12.8714286,8.44206004 12.8714286,7.77142856 C12.8714286,7.10079707 12.3277743,6.55714284 11.6571429,6.55714284 C10.9865114,6.55714284 10.4428571,7.10079707 10.4428571,7.77142856 C10.4428571,8.44206004 10.9865114,8.98571427 11.6571429,8.98571427 Z",
    id: "\\uD83C\\uDFA8-Cor",
    fill: "currentColor"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconErro);
export default __webpack_public_path__ + "static/media/iconErro.673a7122e7e711dc674babfe5785550d.svg";
export { ForwardRef as ReactComponent };